import React from 'react';

import { CollapsibleListSection } from 'ui-components/components/collapsible-list/collapsible-list-section';
import { CollapsibleListSectionContent } from 'ui-components/components/collapsible-list/collapsible-list-section-content';
import { CollapsibleListSectionHeader } from 'ui-components/components/collapsible-list/collapsible-list-section-header';
import { Text, TextType } from 'ui-components/components/text';

import { LazyCodeEditor } from '../../../../../../../../components/editor/lazy-code-editor';
import styles from '../../styles.module.less';

/**
 * @param {object} props
 * @param {string} props.sectionKey
 * @param {import('../../../../../../../../prop-types/intl').MessageDescriptorPropType} props.titleMessage
 * @param {boolean} props.isOpen
 * @param {() => void} props.onSectionClick
 * @param {string} props.value
 * @param {(value: string) => void} props.onChange
 * @param {keyof typeof import('../../../../../../../../components/editor/constants').FIELD_REPLACEMENT_SETS} props.fieldReplacementSet
 * @returns {React.JSX.Element}
 */
export const EditorSection = ({ sectionKey, titleMessage, isOpen, onSectionClick, value, onChange, fieldReplacementSet }) => {
  return (
    <CollapsibleListSection className={styles['section-wrapper']} open={isOpen}>
      <CollapsibleListSectionHeader
        className={isOpen ? styles['open-section'] : styles['closed-section']}
        name={sectionKey}
        onClick={onSectionClick}
      >
        <Text className={styles['section-title']} textType={TextType.Paragraph} value={titleMessage} />
      </CollapsibleListSectionHeader>
      <CollapsibleListSectionContent>
        <LazyCodeEditor onChange={onChange} replacementSet={fieldReplacementSet} value={value} />
      </CollapsibleListSectionContent>
    </CollapsibleListSection>
  );
};
